import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../../baseContainers/BaseContainer';
import moment from 'moment';
import DelegationService from '../../services/DelegationService';
import {t} from 'i18next';
import {acceptedSettlementColor, awaitingSettlementColor, defaultColor, DelegationStatus, enteredSettlementColor, newRequestColor, rejectedSettlementColor, requestRejectedColor} from '../../model/enum/DelegationStatus';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import plLocale from '@fullcalendar/core/locales/pl';
import interactionPlugin from '@fullcalendar/interaction';
import BlockUi from '../../components/waitPanel/BlockUi';
import FullCalendarUtils from '../../utils/FullCalendarUtils';
import Constants from '../../utils/constants';
import {OverlayPanel} from 'primereact/overlaypanel';
import DivContainer from '../../components/DivContainer';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import ActionButton from '../../components/ActionButton';
import {CustomMessages} from '../../components/CustomMessages';


class DelegationCalendarContainer extends BaseContainer {
    constructor(props) {
        super(props, new DelegationService());
        this.calendarRef = React.createRef();

        this.state = {
            loading: true,
            selectedMonth: moment().startOf('month'),
            events: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.getEvents();
    }

    selectedMonth = (date) => {
        this.setState(
            () => ({
                selectedMonth: date,
            }),
            () => {
                this.goToMonth(moment(date).year(), moment(date).month());
            }
        );
    };

    goToMonth(year, month) {
        const calendarApi = this.calendarRef.current.getApi();
        const date = new Date(year, month, 1);
        calendarApi.gotoDate(date);
        this.refresh();
    }
    renderHeaderDetails() {
        const {selectedMonth} = this.state;
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'start',
                    marginTop: '-25px',
                }}
            >
                <i
                    className='timelineHeaderIcon mdi mdi-chevron-left icon-large-plus '
                    style={{marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px'}}
                    onClick={() => {
                        this.selectedMonth(selectedMonth.subtract(1, 'month'));
                    }}
                />
                <i
                    className='timelineHeaderIcon mdi mdi-chevron-right icon-large-plus '
                    style={{marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px'}}
                    onClick={() => {
                        this.selectedMonth(selectedMonth.add(1, 'month'));
                    }}
                />
                <span
                    style={{
                        fontSize: '30px',
                        marginTop: '17px',
                    }}
                >
                    {FullCalendarUtils.getFormattedMonth(selectedMonth)}
                </span>
            </div>
        );
    }
    getEvents() {
        const {selectedMonth} = this.state;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getEvents(selectedMonth)
                    .then((data) => {
                        const customColorData = data.map((element) => ({
                            ...element,
                            backgroundColor: DelegationStatus.getColor(element.status.enumValue),
                            start: element.startDate,
                            end: element.endDate,
                            description: element.purpose,
                        }));
                        this.setState({
                            events: customColorData,
                            loading: false,
                        });
                    })
                    .catch(() => {
                        this.setState({
                            loading: false,
                        });
                        this.showErrorMessage(t('userReporting.eventsError'));
                    });
            }
        );
    }

    refresh() {
        this.getEvents();
    }

    prepareHeaderItems() {
        return [];
    }

    prepareFooterItems() {
        return [];
    }


    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    goNewUrl = () => {
        const {newUrl} = this.props;
        window.location.href = `${newUrl}`;
    };
    eventContent = (eventInfo) => {
        const dateStart = moment(eventInfo.event.start).format(Constants.DATE_GET_REQUEST_FORMAT_TIME);
        const eventid = parseInt(eventInfo.event.id);
        const content = this.state.events.filter((e) => e.id === eventid);
        return this.getEventDetails(content, dateStart);
    };

    goEditUrl(element) {
        const {detailsUrl} = this.props;
        let goDetailsUrl = `${detailsUrl}/${element.id}`;
        window.location.href = goDetailsUrl;
    }

    getEventDetails(content) {
        let eventColor = undefined;

        const events = content.map((event, index) => {
            const op = React.createRef();
            eventColor = DelegationStatus.getColor(event.status.enumValue);
            return (
                <div style={{position: 'relative', width: '100%'}}>
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '100%',
                            backgroundColor: DelegationStatus.getColor(event.status.enumValue),
                            color: 'black',
                            borderRadius: '5px',
                            marginTop: '1%',
                            display: 'flex',
                            cursor: 'pointer',
                            fontSize: '14px',
                            boxShadow: 'none',
                        }}
                        onClick={(e) => {
                            if (!!!this.props.embedded) {
                                op.current.toggle(e);
                            }
                        }}
                    >
                        <span style={{margin: 'auto'}}>{`${event.purpose}` + ' '}</span>
                    </div>

                    {
                        <OverlayPanel ref={op} className='lr-overlay'>
                            <DivContainer colClass='row' rendered={true}>
                                <DivContainer colClass='row'>
                                    <InputTextComponent
                                        id='status'
                                        name='status'
                                        label={'Status'}
                                        colClass='col-md-6'
                                        value={event.status.label}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='type'
                                        name='type'
                                        label={'Typ'}
                                        colClass='col-md-6'
                                        value={event.status.label}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='start'
                                        name='start'
                                        label={'Data od'}
                                        colClass='col-md-6'
                                        value={event.start}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='end'
                                        name='end'
                                        label={'Data do'}
                                        colClass='col-md-6'
                                        value={event.end}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='purpose'
                                        name='purpose'
                                        label={t('delegation.purpose')}
                                        colClass='col-md-12'
                                        value={event.description}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='rejectReason'
                                        name='rejectReason'
                                        label={t('delegation.reasonForRejection')}
                                        colClass='col-md-12'
                                        rendered={event.rejectReason}
                                        value={event.rejectReason}
                                        validator={this.validator}
                                        onChange={this.handleChange}
                                        viewMode={'VIEW'}
                                    />

                                    <div className={'delegation-overlay-button'}>
                                        <ActionButton id="detail-delegation" label='Szczegóły' handleClick={() => this.goEditUrl(event)} />
                                    </div>
                                </DivContainer>
                            </DivContainer>
                        </OverlayPanel>
                    }
                </div>
            );
        });

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    maxWidth: '100%',
                }}
            >
                <div className='row' style={{width: '100%'}}>
                    <label style={{color: 'black', display: 'flex', justifyContent: 'center', backgroundColor: eventColor, margin: 'auto'}}>
                        {events}{' '}
                    </label>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='delegation-daygrid m-3'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    {this.renderHeaderDetails()}
                    <FullCalendar
                        initialDate={this.state.selectedMonth.toDate()}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView='dayGridMonth'
                        locale='pl'
                        ref={this.calendarRef}
                        locales={[plLocale]}
                        events={this.state.events}
                        headerToolbar={{
                            left: 'myCustomButton',
                            center: '',
                            right: '',
                        }}
                        eventDidMount={() => {}}
                        eventContent={this.eventContent}
                        customButtons={{
                            myCustomButton: {
                                id: 'newDelegationButton',
                                text: 'Dodaj wniosek',
                                click: () => {
                                    this.goNewUrl();
                                },
                            },
                        }}
                    />
                    <div>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: newRequestColor}} />
                            Nowy wniosek
                        </span>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: awaitingSettlementColor}}/>
                            Oczekuje rozliczenia
                        </span>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: requestRejectedColor}}/>
                            Wniosek odrzucony
                        </span>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: enteredSettlementColor}}/>
                            Rozliczenie wprowadzone
                        </span>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: acceptedSettlementColor}}/>
                            Rozliczenie zatwierdzone
                        </span>
                        <span className='m-2'>
                            <i className='icon mdi mdi-circle' style={{fontSize: '20px', marginRight: '14px', color: rejectedSettlementColor}}/>
                            Rozliczenie odrzucone
                        </span>
                    </div>
                </BlockUi>
            </div>
        );
    }
}

DelegationCalendarContainer.defaultProps = {
    viewMode: 'EDIT',
    newUrl: '/#/my-delegation/create',
    detailsUrl: '/#/my-delegation/details',
};

DelegationCalendarContainer.propTypes = {
    viewMode: PropTypes.string.isRequired,
};

export default withTranslation()(DelegationCalendarContainer);
